import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';

class TableRemote extends PureComponent {
    static propTypes = {
        Remotes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    /* NAVIGATION */
    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/myfhe/remote/detail/${rowData.id}` });
    };

    /* RENDER */
    renderActions = memoizeOne(profile => {
        const userRights = profile.getIn(['user_rights', 'myfhe'], []);

        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('remoteDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate('general.showDetail')
            });
        }
        return actions;
    });

    renderData = memoizeOne(Remotes => {
        let result = [];

        Remotes.map((Remote, RemoteId) => {
            result.push({
                id: parseInt(RemoteId),
                ref: Remote.get('ref'),
                brand: Remote.get('brand'),
                userEmail: Remote.get('userEmail'),
                tempMin: parseInt(Remote.get('tempMin')),
                tempMax: parseInt(Remote.get('tempMax')),
                ventilationMax: parseInt(Remote.get('ventilationMax'))
            });
        });
        return result;
    });

    renderColumns = memoizeOne(profile => {
        return [
            {
                title: Translator.translate('general.table.column.ref'),
                name: 'ref',
                action: (profile.get('admin') || profile.getIn(['user_rights', 'myfhe'], []).includes('remoteDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate('general.showDetail')
                }
            },
            {
                title: Translator.translate('general.table.column.brand'),
                name: 'brand'
            },
            { title: Translator.translate('general.table.column.email'), name: 'userEmail' },
            {
                title: Translator.translate('general.table.column.tempMin'),
                name: 'tempMin',
                render: (row, data, value) => {
                    if (!value) return null;
                    return <span>{value} °C</span>;
                }
            },
            {
                title: Translator.translate('general.table.column.tempMax'),
                name: 'tempMax',
                render: (row, data, value) => {
                    if (!value) return null;
                    return <span>{value} °C</span>;
                }
            },
            {
                title: Translator.translate('general.table.column.ventilationMax'),
                name: 'ventilationMax'
            }
        ];
    });

    renderRemotes() {
        const { Remotes, profile } = this.props;

        return (
            <FHETable
                idTable="userDetailRemote"
                columns={this.renderColumns(profile)}
                data={this.renderData(Remotes)}
                actions={this.renderActions(profile)}
                minified
            />
        );
    }

    render() {
        const { Remotes } = this.props;
        return (
            <Fragment>
                {Remotes.size > 0 ? this.renderRemotes() : Translator.translate('general.products.Remote.table.body.emptyDataSourceMessage')}
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    let users = state.environments.myfhe.data.Users.get('list');
    let user = state.environments.myfhe.data.Users.getIn(['list', props.match.params.userId], new Map());

    let Remotes = state.environments.myfhe.data.Remote.get('list').filter(Remote => {
        return Remote.get('userId') === parseInt(props.match.params.userId);
    });

    if (Remotes && users) {
        Remotes.map((Remote, key) => {
            if (Remote.get('userId')) {
                let user = users.find(aUser => {
                    return Remote.get('userId') === aUser.get('_id');
                });
                Remotes = Remotes.setIn([key, 'userEmail'], user.get('email'));
            }
        });
    }

    return {
        profile: state.data.user,
        user,
        users,
        Remotes
    };
}

export default withRouter(connect(mapStateToProps)(withTheme(TableRemote)));



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/User/Table/TableRemote.js